<template>
    <!-- 新增当前元素 -->
    <div class="item-add">
        <div class="button-box" v-if="$store.state.token" @click.stop>
            <el-button size="mini" type="primary" v-if="ObjectKey" icon="el-icon-link" @click="changeUrl"></el-button>
            <el-button size="mini" type="primary" v-if="itemIndex === 0 && !buttonType"
                icon="el-icon-circle-plus-outline" @click="add"></el-button>
            <el-button size="mini" type="danger" v-if="!buttonType && list.length > 1" icon="el-icon-remove-outline"
                @click="del"></el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {};
    },
    props: {
        list: {},
        itemIndex: {},
        ObjectKey: {},
        buttonType: {}
    },
    methods: {
        add() {
            let lastObj = JSON.parse(JSON.stringify(this.list[this.list.length - 1] || {}));
            this.$set(this.list, this.list.length, lastObj)
        },
        del() {
            this.list.splice(this.itemIndex, 1);
        },
        changeUrl() {
            this.$prompt('请输入要替换访问地址', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            })
                .then(({ value }) => {
                    this.list[this.itemIndex][this.ObjectKey] = value;
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
        }
    }
};
</script>

<style scoped lang="less">
.item-add {
    position: relative;

    .button-box {
        max-width: 192px;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 50;
        cursor: pointer;
        display: flex;
    }
}
</style>
